<template>
  <div class="user" style="width: 100vw;overflow: hidden;">
    <div class="top">
      <!-- <img src="@assets/images/user_top_bg.png" class="top_bg" alt="" /> -->
      <div class="header acea-row row-between-wrapper">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="pictrue"><img :src="userInfo.avatar" /></div>
          <div class="text">
            <div class="acea-row row-middle">
              <div class="name line1">{{ userInfo.nickname }}</div>
              <div class="">
                <div class="member acea-row row-middle" v-if="userInfo.vip">
                  <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
                </div>
              </div>
            </div>

            <router-link
              :to="'/user/data'"
              class="id"
              v-if="userInfo.account"
              style="margin-top: 0.2rem"
            >
              账号：{{ userInfo.account }}
            </router-link>
            <div
              class="id"
              v-if="userInfo.hx_sf_name"
              style="margin-top: 0.02rem;color: #fff;"
            >
              身份：{{ userInfo.hx_sf_name }}
            </div>
            <div
              class="id"
              v-if="userInfo.tdz_sf_name"
              style="margin-top: 0.02rem;color: #fff;"
            >
              团队长身份：{{ userInfo.tdz_sf_name }}
            </div>
            <router-link
              :to="'/user/binding'"
              class="binding"
              v-if="!userInfo.phone"
            >
              <span>绑定手机号</span>
            </router-link>
          </div>
        </div>
        <span
          class="iconfont icon-shezhi"
          @click="$router.push({ path: '/user/data' })"
        ></span>
      </div>
      <div
        class="nav acea-row row-middle"
        style="border-bottom: 1px solid #ffffff50;"
      >
        <div @click="goPagey2('/user/integral2?type=lsjf')" class="item">
          <div class="num">
            {{ userInfo.lsjf || 0 }}
          </div>
          <div>
            创富积分
            <span @click.stop="$router.push('/user/user_cash?type=lsjf')"
              >提现</span
            >
          </div>
        </div>
        <router-link to="" class="item middle">
          <div
            class="num"
            :style="
              userInfo.today_yx_gxz == '今日未签到' ? 'font-size: 0.3rem;' : ''
            "
          >
            {{ userInfo.today_yx_gxz || 0 }}
          </div>
          <div>今日有效爱心值</div>
        </router-link>
        <div class="item middle" @click="goPagey2('/user/integral2?type=nlz')">
          <div class="num">{{ userInfo.nlz || 0 }}</div>
          <div>生态值</div>
        </div>
      </div>
      <div
        class="nav acea-row row-middle"
        :style="userInfo.store_id ? 'border-bottom: 1px solid #ffffff50;' : ''"
      >
        <div class="item" @click="goPagey2('/user/integral2?type=gxz')">
          <div class="num">{{ userInfo.gxz || 0 }}</div>
          <div>爱心值</div>
        </div>
        <div class="item middle" @click="goPagey2('/user/combination2')">
          <div class="num">{{ userInfo.total_num || 0 }}</div>
          <div>销售业绩</div>
        </div>
        <!-- <div class="item">
          <div class="num">{{ userInfo.zg_box || 0 }}</div>
          <div>个人购买</div>
        </div> -->
        <div class="item" v-if="!userInfo.store_id">
          <div class="num">{{ userInfo.zg_box || 0 }}</div>
          <div>个人购买</div>
        </div>
      </div>
      <div class="nav acea-row row-middle" v-if="userInfo.store_id">
        <div @click="goPagey2('/user/integral2?type=mjf_sj')" class="item">
          <div class="num">
            {{ userInfo.mjf_sj || 0 }}
          </div>
          <div>
            邈积分（商家）
            <span @click.stop="$router.push('/user/user_cash?type=mjf_sj')"
              >提现</span
            >
          </div>
        </div>
        <div class="item middle">
          <div class="num">{{ userInfo.zg_box || 0 }}</div>
          <div>个人购买</div>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unpaid_count > 0"
                >{{ orderStatusNum.unpaid_count }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unshipped_count > 0"
                >{{ orderStatusNum.unshipped_count }}</span
              >
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dsh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.received_count > 0"
                >{{ orderStatusNum.received_count }}</span
              >
            </div>
            <div>待收货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 4 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated_count > 0"
                >{{ orderStatusNum.evaluated_count }}</span
              >
            </div>
            <div>已完成</div>
          </router-link>
          <!-- <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dpj.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated_count > 0"
                >{{ orderStatusNum.evaluated_count }}</span
              >
            </div>
            <div>待评价</div>
          </router-link>
          <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/images/sh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refund_count > 0"
                >{{ orderStatusNum.refund_count }}</span
              >
            </div>
            <div>售后/退款</div>
          </router-link> -->
        </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="
                item.wap_url != '/order/order_cancellation' &&
                  item.wap_url != '/orderAdmin/hxOrderLog' &&
                  item.wap_url != '/orderAdmin/etcardinfo' &&
                  item.wap_url != '/user/apply' &&
                  item.wap_url != '/user/apply3' &&
                  item.wap_url != '/user/apply4' &&
                  item.wap_url != '/order/OrderLog' &&
                  item.wap_url
              "
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url == '/user/apply3' && userInfo.store_id"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="
                item.wap_url == '/order/order_cancellation' &&
                  userInfo.is_hx > 0
              "
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="
                (item.wap_url == '/orderAdmin/hxOrderLog' ||
                  item.wap_url == '/orderAdmin/etcardinfo') &&
                  userInfo.hx_sf > 0
              "
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="
                (item.wap_url == '/user/apply' ||
                  item.wap_url == '/order/OrderLog') &&
                  userInfo.store_id > 0
              "
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <template v-for="(item, index) in MyMenus">
            <div
              class="item"
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url == '/user/apply4' && userInfo.tdz_sf > 0"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
          <!--<div-->
          <!--class="item"-->
          <!--@click="changeswitch(true)"-->
          <!--v-if="userInfo.phone && isWeixin"-->
          <!--&gt;-->
          <!--<div class="pictrue"><img src="@assets/images/switch.png" /></div>-->
          <!--<div>账号切换</div>-->
          <!--</div>-->
        </div>
        <img class="logo" src="@assets/images/logo3.png" alt="" />
      </div>
    </div>
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>

<script>
import { getUser, getMenuUser } from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/SwitchWindow";
import GeneralWindow from "@components/GeneralWindow";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    GeneralWindow
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    this.User();
    this.MenuUser();
    this.isWeixin = isWeixin();
  },
  methods: {
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
        let reg = /^(\d{3})\d*(\d{4})$/;
        that.userInfo.phone = that.userInfo.phone
          ? that.userInfo.phone.replace(reg, "$1****$2")
          : "";
        this.generalContent = {
          promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${res
            .data.promoter_price || 0}元</span>即可开通推广权限`,
          title: "您未获得推广权限"
        };
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPagey(url) {
      if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
        return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
        return (this.generalActive = true);
      }
      this.$router.push({ path: url });
    },
    goPagey2(url) {
      this.$router.push({ path: url });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      if (url === "/user/user_promotion") {
        if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
        if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
          return (this.generalActive = true);
        }
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }
      this.$router.push({ path: this.MyMenus[index].wap_url });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    }
  }
};
</script>

<style lang="scss" scoped>
.footer-line-height {
  height: 1.5rem;
}
.logo {
  width: 3.2rem;
  height: auto;
  margin: 0 2.15rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 50px;
  font-size: 0.14rem;
  color: #ffffff;
}
.top {
  position: relative;
  // background: -webkit-gradient(
  //   linear,
  //   left top,
  //   right top,
  //   from(#0e98fd),
  //   to(#ff6533)
  // );
  // background: linear-gradient(0deg, #0e98fd, #ff6533);
  // background: -webkit-linear-gradient(0deg, #0e98fd, #ff6533);
  background-image: url("../../assets/images/user_top_bg.png");
  background-size: 100% 100%;
  margin-bottom: 0.2rem;
  .top_bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .header {
    z-index: 1;
  }
  .nav {
    position: relative;
    height: 15vw;
    z-index: 1;
    flex-wrap: nowrap;
    > a,
    > div {
      width: 50%;
      text-align: center;
      > .num {
        color: #fff;
        font-size: 4.8vw;
        font-weight: 600;
      }
      span {
        border: 1px solid #fff;
        font-weight: 400;
        font-size: 3.47vw;
        padding: 0 1vw;
        border-radius: 1vw;
        line-height: 6vw;
      }
      > div {
        color: #fff;
        font-size: 2.94vw;
        font-weight: 400;
      }
    }
    > .middle {
      border-left: 1px solid #ffffff50;
      border-right: 1px solid #ffffff50;
    }
  }
}
.red_bag_pic {
  width: 100vw;
  margin-top: 3.5vw;
}
</style>
